import React  , {useState} from 'react'
import Sqaure from './Sqaure'

const Board = () => {
    const [curr,setCurr] = useState(Array(9).fill(null));
    const [xTurn,setXturn] = useState(true);

   const fillValue = (index) =>{
    
    if (curr[index] !== null) {
        return;
      }
       
  const newArray = [...curr];
   newArray[index] = xTurn ? 'X' : 'O';
     setXturn(!xTurn);
     setCurr(newArray);
    }

    const checkWinner = () => {
        const winnerLogic = [
          [0, 1, 2],
          [3, 4, 5],
          [6, 7, 8],
          [0, 3, 6],
          [1, 4, 7],
          [2, 5, 8],
          [0, 4, 8],
          [2, 4, 6],
        ];
    
        for (let logic of winnerLogic) {
          const [a, b, c] = logic;
          if (curr[a] !== null && curr[a] === curr[b] && curr[a] === curr[c]) {
            return curr[a];
          }
        }
    
        return false;
      };
    
      const isWinner = checkWinner();
      const gameReset = () => {
        setXturn(true);
     setCurr(Array(9).fill(null));
      }

      const isDraw = () => {

        for(let i=0;i<9;i++){
          if(curr[i] == null){ 
          return false;
        }
        }
      
        return true;
        // for(let i=0;i<9;i++){ console.log(curr[i]);}
      }

    const drawOrnot = isDraw();
  return (

    
     <div className='board-container'>
    {xTurn ? <h2 >"Hey X it's your turn please move" </h2> : <h2  > "Hey 0 it's your turn please move" </h2>}
    {drawOrnot ? <h3>The game is draw</h3> : <></>} 
    {isWinner ? ( 
        <>
      
       <h3 className='win'>Congrats {isWinner} You have won the Crucial match</h3>   
        <button style = {{height:"10%",backgroundColor: "DodgerBlue",}}onClick={() => gameReset()}>Reset Game</button>
        
        </>
        ) : (
            <>
       <div className='board-rows'>
        <Sqaure onClick ={() => fillValue(0)} value = {curr[0]}/>
        <Sqaure onClick ={() => fillValue(1)} value ={curr[1]}/>
        <Sqaure onClick ={() => fillValue(2)} value ={curr[2]}/>
       </div>

       <div className='board-rows'>
        <Sqaure onClick ={() => fillValue(3)} value ={curr[3]}/>
        <Sqaure onClick ={() => fillValue(4)} value ={curr[4]}/>
        <Sqaure onClick ={() => fillValue(5)} value ={curr[5]}/>
       </div>

       <div className='board-rows'>
        <Sqaure onClick ={() => fillValue(6)} value ={curr[6]}/>
        <Sqaure onClick ={() => fillValue(7)} value ={curr[7]}/>
        <Sqaure onClick ={() => fillValue(8)} value ={curr[8]}/>
       </div>

       <button style = {{height:"10%",backgroundColor: "DodgerBlue",}}onClick={() => gameReset()}>Reset Game</button>
        
        </>

        )}
    </div>
    
)
}

export default Board
